import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=38be846f&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../home/makeeva/projects/mbelab/html/lk.mbelab.com/vue-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38be846f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../home/makeeva/projects/mbelab/html/lk.mbelab.com/vue-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
